import { Box, IconButton } from '@material-ui/core';
import { CloseSharp } from '@material-ui/icons';
import React from 'react';

const CustomCloseButton = ({ onClose }: any) => (
    <Box
        onClick={onClose}
        style={{
            border: 'none',
            cursor: 'pointer',
            // padding: '10px',
            position: 'absolute',
            top: '5px',
            right: '10px'
        }}
    >
        <IconButton >
            <CloseSharp style={{ color: '#000000', alignSelf: 'center' }} />
        </IconButton>
    </Box>
);

export default CustomCloseButton;



// WEBPACK FOOTER //
// ./src/pages/director/DirectorSidebar/CustomCloseButton.tsx